export default /^[a-z0-9!#$%&'*+-/=?^_|{}~](\.?[a-z0-9!#$%&'*+-/=?^_|{}~])*@[a-z](-?[a-z0-9])*(\.[a-z](-?[a-z0-9])+)+$/i;
